import React from "react";
import { openLightbox } from "../../lib/lightbox-store";
import { SkeletonImage } from "../shared/Skeleton";
import EmptyState from "../shared/EmptyState";
import { t } from "../../lib/i18n";

export default function PortfolioRail({ images, loading }) {
  if (loading) {
    return (
      <section
        data-testid="home-portfolio-section"
        className="mx-auto max-w-6xl px-5 py-16 sm:px-6 sm:py-20"
      >
        <h2 className="font-display text-3xl text-[#1A1A1A] sm:text-4xl">
          {t("home.portfolio.title")}
        </h2>
        <div className="mt-10 grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <SkeletonImage key={i} className="aspect-square w-full" />
          ))}
        </div>
      </section>
    );
  }

  if (!images?.length) {
    return (
      <section className="mx-auto max-w-6xl px-5 py-16 sm:px-6 sm:py-20">
        <EmptyState title="Portfolio coming soon" testid="home-portfolio-empty" />
      </section>
    );
  }

  return (
    <section
      data-testid="home-portfolio-section"
      className="mx-auto max-w-6xl px-5 py-16 sm:px-6 sm:py-20"
    >
      <div className="mb-8 flex flex-col gap-3 sm:mb-12 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="font-display text-3xl text-[#1A1A1A] sm:text-4xl">
            {t("home.portfolio.title")}
          </h2>
          <p className="mt-3 max-w-xl text-base text-[#1A1A1A]/60">
            {t("home.portfolio.subtitle")}
          </p>
        </div>
      </div>

      <ul
        data-testid="home-portfolio-grid"
        className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6"
      >
        {images.map((img, idx) => (
          <li key={img.id}>
            <button
              type="button"
              data-testid={`portfolio-thumb-${img.id}`}
              onClick={() => openLightbox(images, idx)}
              className="group block aspect-square w-full overflow-hidden rounded-md bg-[#EAE3D2] focus:outline-none focus:ring-2 focus:ring-[#C8A24B]"
              aria-label={`Open ${img.title || "portfolio image"}`}
            >
              <img
                src={img.thumbnail_url || img.url}
                alt={img.title || "ShutterKART portfolio sample"}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
              />
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
